import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserCard = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.9191 7.10976H15.8081M12.9191 9.99872H15.8081M12.9191 12.8877H15.8081M10.0302 13.8507C9.74127 13.2729 9.06718 12.8877 8.48939 12.8877H5.79302C5.11893 12.8877 4.54114 13.2729 4.25224 13.8507M2.32627 3.25781H17.7341C18.3119 3.25781 18.6971 3.64301 18.6971 4.2208V15.7766C18.6971 16.3544 18.3119 16.7396 17.7341 16.7396H2.32627C2.07087 16.7396 1.82593 16.6382 1.64533 16.4576C1.46474 16.277 1.36328 16.032 1.36328 15.7766V4.2208C1.36328 3.64301 1.74848 3.25781 2.32627 3.25781ZM9.06718 8.07275C9.06718 8.58355 8.86426 9.07343 8.50307 9.43462C8.14188 9.79581 7.652 9.99872 7.1412 9.99872C6.6304 9.99872 6.14052 9.79581 5.77933 9.43462C5.41814 9.07343 5.21523 8.58355 5.21523 8.07275C5.21523 7.56195 5.41814 7.07207 5.77933 6.71088C6.14052 6.34969 6.6304 6.14677 7.1412 6.14677C7.652 6.14677 8.14188 6.34969 8.50307 6.71088C8.86426 7.07207 9.06718 7.56195 9.06718 8.07275Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUserCard;
